import React, { useContext } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';
import {
  AutoSizer,
  Column as VColumn,
  Table as VTable
} from 'react-virtualized';
import headerRenderer from './Header/headerRenderer';
import cellRenderer from './Cell/cellRenderer';
import TableContext from './TableContext';
import { selectionCellRender } from './Selection/SelectionCell';
import { selectionHeaderRender } from './Selection/SelectionHeader';
import {
  headerHeight,
  rowHeight,
  minRowHeight,
  maxRowHeight
} from './constants';
import NoData from './NoData';

const useStyles = makeStyles({
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    outline: 'none'
  },
  tableRowClickable: {
    cursor: 'pointer'
  },
  grid: {
    direction: 'inherit',
    outline: 'none'
  }
});

const TableContentVirtualized = ({ data }) => {
  const classes = useStyles();
  const { columns, selectable, onRowClick } = useContext(TableContext);
  const hasOnRowClick = _.isFunction(onRowClick);

  const getRowClassName = () => {
    return cx(
      classes.tableRow,
      { [classes.tableRowClickable]: hasOnRowClick },
      classes.flexContainer
    );
  };

  const handleClickRow = ({ rowData }) => {
    if (hasOnRowClick) {
      onRowClick(rowData);
    }
  };
  // const _getDatum=(list, index)=> {
  //   return list.get(index % list.size);
  // }
  const _getRowHeight = ({ index }) => {
    let calcRowHeight = minRowHeight;
    // console.log(data[index])
    const keys = Object.keys(data[index]);
    // console.log("60",keys);
    keys.map(item => {
      // console.log(data[index][item]);
      if (
        data[index][item] !== undefined &&
        data[index][item] !== null &&
        data[index][item] !== ''
      ) {
        if (typeof data[index][item] !== 'object') {
          const { length } = data[index][item].toString();
          if (calcRowHeight < length) {
            calcRowHeight = length;
          }
          if (length > maxRowHeight) {
            calcRowHeight = 150;
          }
          if (length < maxRowHeight) {
            if (length > 250) {
              calcRowHeight = length - 120;
            } else if (length > 200 && length < 250) {
              calcRowHeight = length - 100;
            } else if (length > 150 && length < 200) {
              calcRowHeight = length - 80;
            } else if (length > 100 && length < 150) {
              calcRowHeight = length - 60;
            }
          }
        }
      }
    });
    return calcRowHeight;
  };
  return (
    <AutoSizer defaultHeight={400} defaultWidth={600}>
      {({ height, width }) => (
        <VTable
          // Fallback values to make it testable
          height={height || 400}
          width={width || 600}
          rowHeight={_getRowHeight}
          headerHeight={headerHeight}
          gridClassName={classes.grid}
          rowCount={data.length}
          rowGetter={({ index }) => data[index]}
          rowClassName={getRowClassName}
          onRowClick={handleClickRow}
          noRowsRenderer={() => <NoData />}
        >
          {selectable && (
            <VColumn
              dataKey="id"
              headerRenderer={selectionHeaderRender}
              cellRenderer={selectionCellRender}
              className={classes.flexContainer}
              width={48}
              flexShrink={0}
              flexGrow={0}
              columnData={{ tableData: data }}
              key="__selection"
            />
          )}
          {columns.map(column => (
            <VColumn
              dataKey={column.name}
              headerRenderer={headerRenderer}
              cellRenderer={cellRenderer}
              className={classes.flexContainer}
              label={column.label}
              width={column.width}
              flexGrow={column.grow}
              flexShrink={column.shrink}
              columnData={{ config: column }}
              key={column.name}
              className={
                column.name === 'publishedBy' || column.name === 'approveBy'
                  ? 'break-published-by'
                  : ''
              }
            />
          ))}
        </VTable>
      )}
    </AutoSizer>
  );
};

export default TableContentVirtualized;
